module.exports = __webpack_public_path__ + "img/step5.0e213ac3.png";